import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import { useUserData } from 'Foundation/User/UserContext';
import { RichTextPanelType } from '../Models/Panels';

interface IRichTextLinkBoxProps {
  panel: RichTextPanelType;
}
export function RichTextLinkBox({ panel }: IRichTextLinkBoxProps) {
  const { userData } = useUserData();

  return (
    <>
      {userData?.state &&
        panel.linkBoxes &&
        panel.linkBoxes!.map(
          (x, i) =>
            x.States.includes(userData.state) && (
              <RichText key={i} className="slider-panel-link-box" content={x.text} />
            ),
        )}
    </>
  );
}
